import imRequest from '../imRequest';
import { IM_API } from '../../constants/endpoints';

export const messageApi = {
  list: (conversationId, params = {}) =>
    imRequest.get(`${IM_API}/conversations/${conversationId}/messages`, { params }),

  search: (conversationId, params = {}) =>
    imRequest.get(`${IM_API}/conversations/${conversationId}/messages/search`, { params }),

  sendText: (conversationId, body) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/messages`, body),

  sendImage: (conversationId, body) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/messages/image`, body),

  sendSticker: (conversationId, body) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/messages/sticker`, body),

  sendGif: (conversationId, body) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/messages/gif`, body),

  sendAudio: (conversationId, body) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/messages/audio`, body),

  sendVideo: (conversationId, body) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/messages/video`, body),

  sendFile: (conversationId, body) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/messages/file`, body),

  sendLocation: (conversationId, body) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/messages/location`, body),

  sendMapPoint: (conversationId, body) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/messages/map-point`, body),

  sendItinerary: (conversationId, body) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/messages/itinerary`, body),

  sendGroupTrip: (conversationId, body) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/messages/group-trip`, body),

  sendSocialPost: (conversationId, body) =>
    imRequest.post(`${IM_API}/conversations/${conversationId}/messages/social-post`, body),

  revoke: (conversationId, serverMessageId) =>
    imRequest.post(
      `${IM_API}/conversations/${conversationId}/messages/${serverMessageId}/revoke`
    ),

  editText: (conversationId, serverMessageId, text, mentionMemberIds) =>
    imRequest.put(`${IM_API}/conversations/${conversationId}/messages/${serverMessageId}`, {
      text,
      ...(Array.isArray(mentionMemberIds) && mentionMemberIds.length
        ? { mentionMemberIds }
        : {}),
    }),

  putReaction: (conversationId, serverMessageId, emoji) =>
    imRequest.put(
      `${IM_API}/conversations/${conversationId}/messages/${serverMessageId}/reactions`,
      { emoji }
    ),

  removeReaction: (conversationId, serverMessageId, emoji) =>
    imRequest.delete(
      `${IM_API}/conversations/${conversationId}/messages/${serverMessageId}/reactions`,
      { params: { emoji } }
    ),
};
